import $, { Cash } from 'cash-dom'
import { getURLParam } from '../utilities/toolkit.js'

class DynamicCollectionBanner {
  private readonly container: Cash
  private bannerContent: Cash | null = null
  private defaultContent: Cash | null = null
  private dynamicContent: Cash | null = null
  private dynamicHeading: Cash | null = null

  constructor(containerElement: HTMLElement) {
    this.container = $(containerElement)
    this.initialize()
  }

  private initialize(): void {
    this.bannerContent = this.container.find(
      '[data-element="collection-content"]'
    )
    this.defaultContent = this.container.find(
      '[data-element="default-content"]'
    )
    this.dynamicContent = this.container.find(
      '[data-element="dynamic-content"]'
    )
    this.dynamicHeading = this.container.find(
      '[data-element="dynamic-heading"]'
    )

    if (!this.bannerContent.length) {
      return
    }

    this.updateBannerContent()
  }

  private escapeHTML(str: string | null): string {
    if (!str) return ''
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
  }

  private updateBannerContent(): void {
    try {
      const code = getURLParam('c')
      const percentage = getURLParam('p')
      const hasParams = code && percentage

      if (hasParams && this.dynamicContent?.length) {
        this.dynamicContent.removeClass('hidden')

        if (this.dynamicHeading?.length) {
          let headingHtml = this.dynamicHeading.html()
          const codeRegex = /\{code\}/g
          const percentageRegex = /\{percentage\}/g

          const safePercentage = this.escapeHTML(percentage)
          const safeCode = this.escapeHTML(code)

          headingHtml = headingHtml.replace(percentageRegex, safePercentage)
          headingHtml = headingHtml.replace(codeRegex, safeCode)

          this.dynamicHeading.html(headingHtml)
        }
      } else {
        this.defaultContent?.removeClass('hidden')
      }

      this.bannerContent?.addClass('is-visible')
    } catch (e) {
      console.error('Error in DynamicCollectionBanner:', e)
    }
  }
}

$(document).ready(() => {
  $('[data-section-type="dynamic-collection-banner"]').each((_, el) => {
    const _bannerInstance = new DynamicCollectionBanner(el)
  })
})
